import React, { useReducer, useCallback } from 'react';

const CASINO_FILTER_UPDATE = 'CASINO_FILTER_UPDATE';
const CASINO_PROVIDER_FILTER_UPDATE = 'CASINO_PROVIDER_FILTER_UPDATE';

const defaultCasinoFilterState = { providerFilterActive: false };

const CasinoFilterContext = React.createContext(defaultCasinoFilterState);
export const useCasinoFilterState = () => React.useContext(CasinoFilterContext);

const categoryReducer = (state, action) => {
  switch (action.type) {
    case CASINO_FILTER_UPDATE:
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.payload,
        },
      };
    case CASINO_PROVIDER_FILTER_UPDATE:
      return {
        ...state,
        providerFilterActive: action.payload,
      };
    default:
      return state;
  }
};

export const createCasinoInitialState = filter => ({
  ...filter,
  ...defaultCasinoFilterState,
});

const useCasinoFilterStore = initialFilterState => {
  const [state, dispatch] = useReducer(
    categoryReducer,
    initialFilterState,
    createCasinoInitialState,
  );

  const updateFilter = useCallback(filter => {
    dispatch({
      type: CASINO_FILTER_UPDATE,
      payload: filter,
    });
  }, []);

  const setProviderFilter = useCallback(value => {
    dispatch({
      type: CASINO_PROVIDER_FILTER_UPDATE,
      payload: value,
    });
  }, []);

  return {
    ...state,
    updateFilter,
    setProviderFilter,
  };
};

export const CasinoFilterProvider = ({ children, initialFilterState }) => {
  const value = useCasinoFilterStore(initialFilterState);

  return <CasinoFilterContext.Provider value={value}>{children}</CasinoFilterContext.Provider>;
};
